import quickButtonScenario from "./quickButtonScenario";
import textTile from "./textTile";

// Keyed by the tile descriptor's `config` field (see tiles.js).
const Configs = {
  quickButtonScenario,
  textTile,
};

export default Configs;
